var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthFailure',{scopedSlots:_vm._u([{key:"textSlot",fn:function(){return [_c('h2',{staticStyle:{"max-width":"420px"}},[_vm._v("Ваша учетная запись"),_c('br'),_vm._v("заблокирована")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }